import { isLoggedIn } from 'utils/auth';

export default (store) => ({
  path: "create-cohorts",
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure(
      [],
      (require) => {
        const component = require("./CreateCohorts").default;
        callback(null, component);
      },
      "CreateCohorts"
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/CreateCohorts/index.js